import { render, staticRenderFns } from "./BaseSelectModal.vue?vue&type=template&id=f60e375a&scoped=true&"
import script from "./BaseSelectModal.vue?vue&type=script&lang=js&"
export * from "./BaseSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectModal.vue?vue&type=style&index=0&id=f60e375a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e375a",
  null
  
)

export default component.exports